!function(t) {
    "use strict";
    function i(t, i, e) {
        return i in t ? Object.defineProperty(t, i, {
            value: e,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[i] = e,
        t
    }
    let e = () => {
        window.removeEventListener("gp-global-loaded", e);
        class t extends GP.Component {
            isScrollToElement() {
                var t, i;
                return null !== (i = this.btnLinkSetting) && void 0 !== i && null !== (t = i.link) && void 0 !== t && !!t.startsWith("#") && ("_self" === this.btnLinkSetting.target || "scroll-to" === this.btnLinkSetting.type)
            }
            beforeScrollToElement(t) {
                var i, e;
                if (!(null === (i = this.btnLinkSetting) || void 0 === i ? void 0 : i.link))
                    return;
                let n = document.querySelector(null == t ? void 0 : t.link)
                  , o = null == n ? void 0 : n.closest(".gps-lazy");
                if (!o) {
                    null === (e = this.triggerButtonLinkSub) || void 0 === e || e.click();
                    return
                }
                this.mutationDom(o)
            }
            mutationDom(t) {
                let i = new MutationObserver(t => {
                    var i, e, n;
                    let o = !(null !== (n = null === (i = null === (e = t[0]) || void 0 === e ? void 0 : e.target) || void 0 === i ? void 0 : i.className) && void 0 !== n ? n : "").includes("gps-lazy");
                    o && this.triggerButtonLinkSub && this.triggerButtonLinkSub.click()
                }
                );
                t && i.observe(t, {
                    attributes: !0,
                    attributeFilter: ["class"]
                })
            }
            constructor() {
                super(),
                i(this, "buttonLink", void 0),
                i(this, "triggerButtonLinkSub", void 0),
                i(this, "btnLinkSetting", void 0),
                i(this, "init", async () => {
                    if (this.isScrollToElement()) {
                        var t;
                        null === (t = this.buttonLink) || void 0 === t || t.addEventListener("click", () => this.beforeScrollToElement(this.btnLinkSetting))
                    }
                }
                ),
                this.buttonLink = this.querySelector(".gp-button-base"),
                this.triggerButtonLinkSub = this.querySelector(".gp-trigger-button-link"),
                this.btnLinkSetting = this.getState("btnLink"),
                this.init()
            }
        }
        customElements.get("gp-button") || customElements.define("gp-button", t)
    }
    ;
    "completed" === window.gpReadyState ? e() : window.addEventListener("gp-global-loaded", e),
    t.defineComponentGPButton = e
}({});
